// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../decco/src/Decco.bs.js";
import * as MomentUtils$Catalyst from "../date/moment-utils/MomentUtils.bs.js";

var t_encode = Decco.floatToJson;

var t_decode = Decco.floatFromJson;

function make(v) {
  return v;
}

var setTz = MomentUtils$Catalyst.setTz;

function now(param) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.now(undefined));
}

function toString(value, format) {
  return MomentUtils$Catalyst.formatFromFloat(format, value);
}

function utcToIst(value) {
  return value + 19800000.0;
}

function toFloat(timestamp) {
  return timestamp;
}

function isBefore(first_date, second_date) {
  return first_date < second_date;
}

function isAfter(first_date, second_date) {
  return first_date > second_date;
}

function getDateTimeAfterElapsedTime(elapsed_time, time_unit, initial_date) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.getDateTimeAfterElapsedTime(elapsed_time, time_unit, MomentUtils$Catalyst.fromTimestampMs(initial_date)));
}

function tomorrow(param) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.getDateTimeAfterElapsedTime(1, /* Days */4, MomentUtils$Catalyst.now(undefined)));
}

function getDateTimeBeforeElapsedTime(elapsed_time, time_unit, initial_date) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.getDateTimeBeforeElapsedTime(elapsed_time, time_unit, MomentUtils$Catalyst.fromTimestampMs(initial_date)));
}

function getPreviousDateByDays(day) {
  return getDateTimeBeforeElapsedTime(day, /* Days */4, MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.now(undefined)));
}

function startOf(ts, scale_unit) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.startOf(MomentUtils$Catalyst.fromTimestampMs(ts), scale_unit));
}

function endOf(ts, scale_unit) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.endOf(MomentUtils$Catalyst.fromTimestampMs(ts), scale_unit));
}

function secondsToMilliSeconds(ts) {
  return ts * 1000.0;
}

function milliSecondsToSeconds(ts) {
  return ts / 1000.0 | 0;
}

function day(ts) {
  return MomentUtils$Catalyst.day(MomentUtils$Catalyst.fromTimestampMs(ts));
}

function dateStringToTimestamp(date, format) {
  return MomentUtils$Catalyst.toFloat(MomentUtils$Catalyst.fromString(date, format));
}

export {
  t_encode ,
  t_decode ,
  make ,
  setTz ,
  now ,
  toString ,
  isBefore ,
  isAfter ,
  getDateTimeAfterElapsedTime ,
  tomorrow ,
  getDateTimeBeforeElapsedTime ,
  getPreviousDateByDays ,
  utcToIst ,
  toFloat ,
  startOf ,
  endOf ,
  secondsToMilliSeconds ,
  milliSecondsToSeconds ,
  day ,
  dateStringToTimestamp ,
  
}
/* MomentUtils-Catalyst Not a pure module */
